module.exports = __webpack_public_path__ + "img/bg-lg-04.44a943a7.jpg";